import { render, staticRenderFns } from "./reverse-relevance.vue?vue&type=template&id=5d9cd704&scoped=true&"
import script from "./reverse-relevance.ts?vue&type=script&lang=ts&"
export * from "./reverse-relevance.ts?vue&type=script&lang=ts&"
import style0 from "./reverse-relevance.vue?vue&type=style&index=0&id=5d9cd704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9cd704",
  null
  
)

export default component.exports